import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-rules-terms',
  templateUrl: './rules-terms-iraq.component.html',
  styleUrls: ['./rules-terms-iraq.component.scss']
})
export class RulesTermsTecnoIraqComponent implements OnInit {
  constructor(public globalService:GlobalService) { }

  ngOnInit(): void {
  }


}
